import { useState, useEffect } from "react";

/** Milliseconds from now until the next 00:00:00.000 UTC. */
export function msUntilNextUtcMidnight(nowMs = Date.now()) {
  const d = new Date(nowMs);
  const nextUtcMidnight = Date.UTC(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate() + 1,
    0,
    0,
    0,
    0
  );
  return Math.max(0, nextUtcMidnight - nowMs);
}

/** `HH:MM:SS` until next UTC midnight. */
export function formatUtcMidnightCountdown(ms) {
  if (ms <= 0) return "00:00:00";
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  return [h, m, s].map((n) => String(n).padStart(2, "0")).join(":");
}

/**
 * Re-renders with remaining ms until UTC midnight (default tick 1s).
 * Cheap: one interval per mounted component using this hook.
 */
export function useUtcMidnightCountdown(tickMs = 1000) {
  const [remainingMs, setRemainingMs] = useState(() => msUntilNextUtcMidnight());

  useEffect(() => {
    const tick = () => setRemainingMs(msUntilNextUtcMidnight());
    tick();
    const id = setInterval(tick, tickMs);
    return () => clearInterval(id);
  }, [tickMs]);

  return remainingMs;
}
